import { render } from "./AppLayout.vue?vue&type=template&id=722d1d67&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=722d1d67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722d1d67"]])

export default __exports__